var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUzioLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 43,
    viewBox: "0 0 60 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1002_15158",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V42.7945H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1002_15158)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1002_15158",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49451 0.000976562H54.5192C55.9764 0.000976562 57.3741 0.581946 58.4043 1.61597C59.4349 2.65038 60.0137 4.05321 60.0137 5.51578V37.252C60.0137 40.2977 57.5538 42.7668 54.5192 42.7668H5.49451C2.45994 42.7668 0 40.2977 0 37.252V5.51578C0 4.05321 0.578831 2.65038 1.60905 1.61597C2.63965 0.581946 4.03732 0.000976562 5.49451 0.000976562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1002_15158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6954 5.51609C58.6954 4.42188 58.2691 3.37168 57.5086 2.58923L57.4722 2.55217C56.6894 1.76643 55.6271 1.32484 54.5196 1.32484H5.49483C4.38734 1.32484 3.32501 1.76639 2.54167 2.55232C1.75882 3.33852 1.319 4.40465 1.319 5.51609V37.2523C1.31901 39.5671 3.18855 41.4435 5.49483 41.4435H54.5196C56.8258 41.4435 58.6954 39.5671 58.6954 37.2523V5.51609ZM61.3327 37.2523C61.3327 41.029 58.2824 44.0906 54.5196 44.0906H5.49483C1.73198 44.0906 -1.31835 41.029 -1.31836 37.2523V5.51609C-1.31836 3.70255 -0.600625 1.96317 0.676762 0.680585L0.677119 0.680226L0.737358 0.620554C2.00916 -0.624202 3.71619 -1.32227 5.49483 -1.32227H54.5196C56.3264 -1.32227 58.0595 -0.601936 59.3371 0.68037L59.3966 0.740832C60.6373 2.01739 61.3327 3.73085 61.3327 5.51609V37.2523Z",
    fill: "#121732"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1002_15158",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 56,
    height: 39
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72363 2.47168H57.3024V40.2665H2.72363V2.47168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1002_15158)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1002_15158",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 56,
    height: 39
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38664 2.4709H53.6256C55.6487 2.4709 57.2883 4.11692 57.2883 6.14744V36.6144C57.2883 38.645 55.6487 40.291 53.6256 40.291H6.38664C4.36359 40.291 2.72363 38.645 2.72363 36.6144V6.14744C2.72363 4.11692 4.36359 2.4709 6.38664 2.4709Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1002_15158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.969 6.14873C55.969 4.849 54.9196 3.79574 53.625 3.79574H6.38598C5.09122 3.79574 4.04166 4.84918 4.04166 6.14873V36.6157C4.04166 37.9153 5.09122 38.9687 6.38598 38.9687H53.625C54.9196 38.9687 55.969 37.9155 55.969 36.6157V6.14873ZM58.6063 36.6157C58.6063 39.3771 56.3765 41.6158 53.625 41.6158H6.38598C3.63465 41.6158 1.4043 39.3772 1.4043 36.6157V6.14873C1.4043 3.38723 3.63465 1.14864 6.38598 1.14864H53.625C56.3765 1.14864 58.6063 3.38741 58.6063 6.14873V36.6157Z",
    fill: "#121732"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2341 14.4951V22.9649C11.2341 23.8933 11.4745 24.6025 11.956 25.0927C12.4383 25.5829 13.1152 25.828 13.9874 25.828C14.8734 25.828 15.5572 25.5829 16.0387 25.0927C16.521 24.6025 16.7621 23.8933 16.7621 22.9649V14.4951H19.517V22.945C19.517 24.1093 19.266 25.0935 18.7646 25.897C18.2628 26.7008 17.5917 27.3056 16.7515 27.7107C15.912 28.1163 14.978 28.3189 13.9493 28.3189C12.9328 28.3189 12.0109 28.1163 11.1837 27.7107C10.3572 27.3056 9.70324 26.7008 9.22094 25.897C8.73941 25.0935 8.49902 24.1093 8.49902 22.945V14.4951H11.2341Z",
    fill: "#121732"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9477 25.8679H31.0817V28.181H21.7822V26.064L27.8781 16.8083H21.7822V14.4951H31.0817V16.6122L24.9477 25.8679Z",
    fill: "#121732"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1413 14.4951V28.181H33.4062V14.4951H36.1413Z",
    fill: "#121732"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1652 28.3245C43.8892 28.3245 42.7171 28.0239 41.6487 27.4223C40.5811 26.821 39.7348 25.9877 39.109 24.9222C38.484 23.8572 38.1719 22.6512 38.1719 21.3039C38.1719 19.9712 38.484 18.7724 39.109 17.707C39.7348 16.6408 40.5811 15.8075 41.6487 15.207C42.7171 14.6057 43.8892 14.3047 45.1652 14.3047C46.4552 14.3047 47.6308 14.6057 48.6923 15.207C49.7535 15.8075 50.5933 16.6408 51.2122 17.707C51.8307 18.7724 52.1401 19.9712 52.1401 21.3039C52.1401 22.6512 51.8307 23.8572 51.2122 24.9222C50.5933 25.9877 49.75 26.821 48.6816 27.4223C47.614 28.0239 46.4419 28.3245 45.1652 28.3245ZM45.1652 25.8735C45.9863 25.8735 46.709 25.6874 47.334 25.3144C47.9597 24.9418 48.4481 24.409 48.7992 23.7166C49.151 23.0234 49.3272 22.2192 49.3272 21.3039C49.3272 20.389 49.151 19.5882 48.7992 18.9019C48.4481 18.2156 47.9597 17.6898 47.334 17.324C46.709 16.9575 45.9863 16.7741 45.1652 16.7741C44.3448 16.7741 43.6191 16.9575 42.9872 17.324C42.3553 17.6898 41.8631 18.2156 41.5113 18.9019C41.1603 19.5882 40.9848 20.389 40.9848 21.3039C40.9848 22.2192 41.1603 23.0234 41.5113 23.7166C41.8631 24.409 42.3553 24.9418 42.9872 25.3144C43.6191 25.6874 44.3448 25.8735 45.1652 25.8735Z",
    fill: "#121732"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzioLogoBlack);
export default __webpack_public_path__ + "static/media/UzioLogo-black.518dd4559af3ee32f4ae38bbddc79a7a.svg";
export { ForwardRef as ReactComponent };